import { ReceivableResponse } from '@efex-services/receivables/types';
import { Button } from '@efexteam/components';
import { Actions, Can, Subjects } from '@efexteam/permission-manager';
import { TableBody, TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TableRowsServiceProps } from '../services/TableConvertData.service';
import ReceivablesTableStyles from '../ReceivablesTable.style';

interface RowsProps {
  receivables: ReceivableResponse[];
  rowsData: TableRowsServiceProps[];
  showInvoice: (uuid: string, paymentId: number) => void;
  isMobile: boolean;
}

const TableRows = ({
  rowsData,
  receivables,
  showInvoice,
  isMobile,
}: RowsProps) => {
  const { t } = useTranslation();

  const renderMovementsRow = (rows: TableRowsServiceProps[]): JSX.Element => (
    <>
      {rows.map((row, index) => (
        <TableRow key={row.id}>
          <TableCell className={ReceivablesTableStyles.tableCell(!isMobile)}>
            <div className={ReceivablesTableStyles.clientNameCell}>
              <section className="client-name-section">
                <p className="client-name-text">{row.rvlName}</p>
              </section>
            </div>
          </TableCell>
          <TableCell className={ReceivablesTableStyles.tableCell()}>
            {row.rvlStatus}
          </TableCell>
          <TableCell className={ReceivablesTableStyles.tableCell()}>
            {row.rvlAmount}
          </TableCell>
          <TableCell className={ReceivablesTableStyles.tableCell()}>
            {row.rvlDate}
          </TableCell>
          <TableCell className={ReceivablesTableStyles.actionCell}>
            {receivables[index] ? (
              <Can action={Actions.READ} subject={Subjects.PAYMENTS}>
                <Button
                  appearance="secondary"
                  onClick={() =>
                    showInvoice(receivables[index].uuid, receivables[index].id)
                  }
                >
                  {t('viewAll')}
                </Button>
              </Can>
            ) : null}
          </TableCell>
        </TableRow>
      ))}
    </>
  );

  return <TableBody>{renderMovementsRow(rowsData)}</TableBody>;
};

export default TableRows;
